import styled from 'styled-components';
import {ReactNode, useEffect, useRef, MouseEvent} from "react";
import {useStoreModal, useStoreModalValue} from "../../../store/modal";

const Modal = ({title, children}: { title?: string, children?: ReactNode }) => {
    const {closeModal} = useStoreModal();
    const modalRef = useRef<HTMLDivElement>(null);
    const {show, title: stateTitle, maxWidth: stateMaxWidth, children: stateChildren, isCloseButton} = useStoreModalValue();

    useEffect(() => {
        const el = document.querySelector('body');
        if (el) el.style.overflow = show ? 'hidden' : '';
    }, [show]);

    const onModalClose = (e: MouseEvent<HTMLDivElement>) => {
        if (modalRef.current === e.target) closeModal();
    };

    if (!show) return (<></>);
    if (show && (!children && !stateChildren)) return (<></>);

    return (
        <ModalWrap onClick={(e) => onModalClose(e)} ref={modalRef}>
            <ModalInnerWrap $maxWidth={stateMaxWidth}>
                {
                    isCloseButton &&
                    <ModalHeaderWrap>
                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"
                             onClick={closeModal}
                        >
                            <path
                                d="M16 18.3747L20.0823 22.4566C20.4051 22.7797 20.8008 22.9377 21.2692 22.9306C21.7379 22.9232 22.1337 22.7581 22.4566 22.4352C22.7797 22.112 22.9413 21.7163 22.9413 21.2478C22.9413 20.7794 22.7797 20.3836 22.4566 20.0605L18.3747 16L22.4566 11.9178C22.7797 11.5949 22.9413 11.1992 22.9413 10.7308C22.9413 10.2621 22.7797 9.86632 22.4566 9.54344C22.1337 9.2203 21.7379 9.05873 21.2692 9.05873C20.8008 9.05873 20.4051 9.2203 20.0823 9.54344L16 13.6253L11.9178 9.54344C11.5949 9.2203 11.2028 9.05873 10.7415 9.05873C10.2802 9.05873 9.88795 9.2203 9.56481 9.54344C9.24193 9.86632 9.08048 10.2621 9.08048 10.7308C9.08048 11.1992 9.24193 11.5949 9.56481 11.9178L13.6253 16L9.54344 20.0822C9.2203 20.4051 9.06229 20.7972 9.06942 21.2585C9.07679 21.7198 9.24193 22.112 9.56481 22.4352C9.88795 22.7581 10.2837 22.9195 10.7522 22.9195C11.2206 22.9195 11.6164 22.7581 11.9395 22.4352L16 18.3747ZM16 32C13.7731 32 11.6879 31.5813 9.74419 30.744C7.80052 29.9063 6.10925 28.7682 4.67039 27.3296C3.23178 25.8907 2.09367 24.1995 1.25605 22.2558C0.418682 20.3121 0 18.2269 0 16C0 13.7731 0.418682 11.6879 1.25605 9.74419C2.09367 7.80052 3.23178 6.10925 4.67039 4.67039C6.10925 3.23178 7.80052 2.09367 9.74419 1.25605C11.6879 0.418681 13.7731 0 16 0C18.2269 0 20.3121 0.418681 22.2558 1.25605C24.1995 2.09367 25.8907 3.23178 27.3296 4.67039C28.7682 6.10925 29.9063 7.80052 30.744 9.74419C31.5813 11.6879 32 13.7731 32 16C32 18.2269 31.5813 20.3121 30.744 22.2558C29.9063 24.1995 28.7682 25.8907 27.3296 27.3296C25.8907 28.7682 24.1995 29.9063 22.2558 30.744C20.3121 31.5813 18.2269 32 16 32Z"
                                fill="white" fill-opacity="0.5"/>
                        </svg>

                    </ModalHeaderWrap>
                }

                <ModalContentWrap>
                    {stateChildren && stateChildren}
                    {children && children}
                </ModalContentWrap>
            </ModalInnerWrap>
        </ModalWrap>
    );
}

const ModalWrap = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.6);
  padding: 0 40px;
  z-index: 10;

  animation: fadeIn 0.4s;

  @media screen and (max-width: 768px) {
    padding: 0 20px;
  }
`;

const ModalInnerWrap = styled.div<{ $maxWidth?: string }>`
  width: 100%;
  max-width: ${({$maxWidth}) => $maxWidth ? $maxWidth : '900px'};
  max-height: 90vh;
  border-radius: 40px;
  box-shadow: rgb(0 0 0 / 15%) 0 0 6px 0;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  position: relative;
  margin: auto auto;
`

const ModalHeaderWrap = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;

  & > svg {
    position: absolute;
    right: 0px;
    top: -45px;
    cursor: pointer;
  }
`

const ModalContentWrap = styled.div`
  width: 100%;
  overflow: auto;
`

export default Modal;
